import script from "./ReservationsSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationsSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationsSkeleton.vue?vue&type=style&index=0&id=59da7492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59da7492"]])

export default __exports__